// extracted by mini-css-extract-plugin
export default {"signatureField":"JD6Z4_","header":"SAy64d","inputContainer":"GdeDha"};